// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-field-date[data-v-4e05be8c]{position:relative}.text-field-date .text-field-date__header[data-v-4e05be8c]{align-items:center;display:flex;justify-content:space-between;margin-bottom:1.5rem;margin-left:auto;margin-right:auto;max-width:370px;padding-left:.75rem;padding-right:.75rem}@media (min-width:768px){.text-field-date .text-field-date__header[data-v-4e05be8c]{display:none}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
